import { render, staticRenderFns } from "./PlayerProcessedVideoDivideLayout.vue?vue&type=template&id=45fffe47&scoped=true&"
import script from "./PlayerProcessedVideoDivideLayout.vue?vue&type=script&lang=js&"
export * from "./PlayerProcessedVideoDivideLayout.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProcessedVideoDivideLayout.vue?vue&type=style&index=0&id=45fffe47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fffe47",
  null
  
)

export default component.exports